module.exports = __webpack_public_path__ + "img/logo.3ca8e32e.png";